export default __webpack_public_path__ + "static/dust1-fc099179c87cc95565b8c4d935990417.png";